import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Models
import { INotificationItem } from '../../interfaces/notifications.interfaces';

export interface INotificationsState {
  list: INotificationItem[],
  total: number;
  unread_count: number;
  isFirstLoad: boolean;
  loading: boolean;
  error: string | null;
}

const initialState: INotificationsState = {
  list: [],
  total: 0,
  unread_count: 0,
  isFirstLoad: true,
  loading: false,
  error: null
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    getNotificationsRequest(state, { payload: { isFirstLoad } }: PayloadAction<{ isFirstLoad?: boolean }>) {
      state.loading = true;
      state.isFirstLoad = isFirstLoad ?? false;
      state.error = null;
    },
    getNotificationsRequestSuccess: (state, { payload: { list, total, isFirstLoad } }: PayloadAction<{
      list: INotificationItem[],
      total: number,
      isFirstLoad: boolean,
    }>) => {
      state.list = isFirstLoad ? list : [...state.list, ...list];
      state.total = total ?? 0;
      state.loading = false;
      state.isFirstLoad = isFirstLoad;
      state.error = null;
    },
    getNotificationsRequestFailure: (state, { payload: error }: PayloadAction<string>) => {
      state.loading = false;
      state.isFirstLoad = false;
      state.error = error;
    },
    setUnreadCount: (state, { payload: unread_count }: PayloadAction<number>) => {
      state.unread_count = unread_count;
    },
    markAsReadNotifications: (state) => {
      state.unread_count = 0;
    },
    deleteNotifications: (state, { payload: { notifications_id, total } }: PayloadAction<{ notifications_id?: number, total: number }>) => {
      state.list = notifications_id ? state.list.filter(notification => notification.id !== notifications_id) : [];
      state.total = notifications_id ? total : 0;
      state.loading = false;
      state.error = null;
    },
    clearNotifications: (state) => {
      state.list = [];
      state.isFirstLoad = true;
      state.total = 0;
      state.loading = true;
      state.error = null;
    }
  }
});

export const NotificationsSliceActions = notificationsSlice.actions;
